/**
 * @title Initialise Smooth Scrolling
 * @description Logic for handling the smooth scrolling feature
 */
function smoothScrolling() {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault()

      document.querySelector(this.getAttribute("href")).scrollIntoView({
        behavior: "smooth",
        block: "center",
      })
    })
  })
}

export default smoothScrolling
